import { Landmark, Wallet, Smartphone, CreditCard } from "lucide-react";

const STYLE = {
  bank: { icon: Landmark, cls: "border-blue-200 bg-blue-50 text-blue-700" },
  kas: { icon: Wallet, cls: "border-emerald-200 bg-emerald-50 text-emerald-700" },
  ewallet: { icon: Smartphone, cls: "border-violet-200 bg-violet-50 text-violet-700" },
  lainnya: { icon: CreditCard, cls: "border-slate-200 bg-slate-50 text-slate-700" },
};

/** Kartu kecil penanda sumber akun (BCA, Mandiri, Shopee, dll). */
export default function AkunChip({ akun, testid }) {
  if (!akun) return <span className="text-slate-400 text-xs" data-testid={testid}>-</span>;
  const st = STYLE[akun.tipe] || STYLE.lainnya;
  const Icon = st.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 max-w-[150px] rounded-md border px-2 py-0.5 text-[11px] font-medium shadow-sm ${st.cls}`}
      title={akun.nama}
      data-testid={testid}
    >
      <Icon size={11} className="shrink-0" />
      <span className="truncate">{akun.nama}</span>
    </span>
  );
}
